import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { url } from '../../../constants/routes';
import { connect } from '../../../reducers/index';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
import SingleSelectQuestions from '../../../components/Questions/SingleSelectQuestions';
import UnClickableScreenReader from '../../../components/ScreenReader/UnClickableScreenReader';
// import AssistGraphic from '../img/assist-graphic.svg';
// import AssistGraphic02 from '../img/assist-prof-holding-map-graphic.svg';

const AssistPage = props => {
  const questions = {
    //title: 'Question 5a: Strategies',
    type: 'single',
    text: (
      <Fragment>
        <UnClickableScreenReader
          text={`Personal Reflection: How do you feel when using this component when trying to assist someone?`}
        />
        <strong>
          Personal Reflection: How do you feel when using this component when trying to assist someone?
        </strong>
      </Fragment>
    ),
    result: [],
    feedback: {
      correct: '',
      incorrect: '',
      all: ''
    }
  };
  const options = [
    {
      prefix: 'A',
      result: '',
      optionText:
        'I have to be really focused and intentional when doing this.'
    },
    {
      prefix: 'B',
      result: '',
      optionText:
        'I am often able to do this but it’s a good reminder.'
    },
    {
      prefix: 'C',
      result: '',
      optionText:
        'I always do this.'
    }
  ];
  return (
    <EducationModuleLayout
      progressStage={3}
      childTitle="Assist"
      progressType="assist"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col xs={10} xsOffset={1}>
              <UnClickableScreenReader text="1. Choose a place and time" />
              <h2 className="txt-green no-bold no-margin">
                1. Choose a place and time
              </h2>
            </Col>
          </Row>
        </div>
      </section>
      <section className="no-bottom-padding">
        <div className="container">
          <Row>
            <Col xs={10} xsOffset={1}>
              {/* <UnClickableScreenReader text="1. Choose the place and time" />
              <strong>1. Choose the place and time</strong> */}
              <UnClickableScreenReader text="Whenever possible, choose a place and time with the individual that respects their privacy and has minimal distractions. This allows both yourself and the person you’re concerned about to have a meaningful and uninterrupted conversation. By creating a comfortable environment, the individual may be more willing to discuss personal issues that they may be experiencing. Complete the following reflection exercise to determine your comfort level with this component. Personal Reflection: How do you feel about using this approach within a helping conversation? (select one)" />
              <p>
                Whenever possible, choose a place and time with the individual that
                respects their privacy and has minimal distractions. This allows you both to have a meaningful
                and uninterrupted conversation. By creating a comfortable environment,
                the individual may be more willing to discuss personal issues that they
                may be experiencing. Complete the following reflection exercise to
                determine your comfort level with this component.
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <SingleSelectQuestions
        questions={questions}
        options={options}
        questionType="assist"
        categoary="survey"
        showLetter={false}
        nextRoute={url.ASSIST_D}
        previousRoute={() => props.history.goBack()}
      />
    </EducationModuleLayout>
  );
};

AssistPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const AssistC = connect.role(AssistPage);

export default AssistC;



// WEBPACK FOOTER //
// ./src/containers/Assist/AssistC/index.jsx